import React from "react";
import {
  DC_STATE_CODE,
  REVIEW_SPECIAL_STATES,
  SPECIAL_STATES,
  FEDERAL_STATES,
  SPECIAL_STATE_TAX,
} from "../../settings/settings";
import { FEDERAL_WITHOLDINGS } from "../../settings/settings";
import { sortStatesList } from '../../utils/utils';

const { ELECT_FEDERAL_WITHHOLDING } = FEDERAL_WITHOLDINGS;

const ReviewTaxwithholdingMessage = ({
  withHoldingState,
  selected,
  mandatory,
  multiState,
  stateList,
  value,
  percentage,
}) => {
  let stateCode;
  if (withHoldingState) {
    stateCode = withHoldingState.stateCode;
  }

  if (multiState) {
    stateList = sortStatesList(stateList, "stateName");
  }

  const isSpecialState = SPECIAL_STATES.indexOf(stateCode) > -1;

  const isFederalState = FEDERAL_STATES.indexOf(stateCode) > -1;

  const isMinnesota = SPECIAL_STATE_TAX.indexOf(stateCode) > -1;

  const isWithholdingSelected = selected === ELECT_FEDERAL_WITHHOLDING;

  const witholdingMessage = (
    <div>{`${value}% Federal Income Tax Withholding`}</div>
  );

  const isSpecialDistributionState =
    REVIEW_SPECIAL_STATES.indexOf(stateCode) > -1;

  const declinedWithHoldingMessage = (
    <div>Declined Federal Income Tax Withholding</div>
  );


  const specialStateMessage = isWithholdingSelected
    ? witholdingMessage
    : declinedWithHoldingMessage;

  if (mandatory && multiState) {
    return (
      <div>
        {specialStateMessage}
        <div>
          {`There are multiple states associated with your investments. State taxes
        will be withheld accordingly.`}
        </div>
      </div>
    );
  } else if (isSpecialState) {
    switch (stateCode) {
      case DC_STATE_CODE:
        return (
          <div>
            {specialStateMessage}
            <div>
              State Income Tax Withholding for {withHoldingState.stateName} (
                  {percentage}% of the distribution) is only applied when taking a total distribution.
            </div>
          </div>
        );

      default:
        return (
          <div>
            {specialStateMessage}
            <div>
              State Income Tax Withholding for{' '}{withHoldingState.stateName}{' '}
                  ({percentage}% of the distribution) will be applied.

            </div>
          </div>
        );
    }
  } else if (isSpecialDistributionState) {
    if (isWithholdingSelected) {
      return (
        <div>
          {witholdingMessage}
          <div>{`Your investments are associated with an address in ${withHoldingState.stateName}, where state tax withholding is ${percentage}% of a distribution more than $200.`}</div>
        </div>
      );
    } else {
      return (
        <div>
          {declinedWithHoldingMessage}
          <div>{`${withHoldingState.stateName} state income tax withholding not available.`}</div>
        </div>
      );
    }
  } else if (isMinnesota) {
    return (
      <div>
        {specialStateMessage}
        <div>
          {`State Income Tax Withholding for ${withHoldingState.stateName} will be applied.`}
        </div>
      </div>
    );
  } else if (mandatory) {
    if (isWithholdingSelected) {
      return (
        <div>
          {witholdingMessage}
          <div>{`${
            withHoldingState.stateName
          } state income tax withholding (${percentage}% of ${
            isFederalState ? "federal withholding" : "the distribution"
          }) will be applied.`}</div>
        </div>
      );
    } else {
      return (
        <div>
          {declinedWithHoldingMessage}
          <div>{`${withHoldingState.stateName} state income tax withholding not available.`}</div>
        </div>
      );
    }
  } else if (multiState) {
    if (isWithholdingSelected) {
      return (
        <div>
          {witholdingMessage}
          <div>
            State income tax withholding for the states associated with your
            investments will not be applied.{" "}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {declinedWithHoldingMessage}
          <div>
            State income tax withholding for the states associated with your
            investments will not be applied.{" "}
          </div>
        </div>
      );
    }
  } else {
    if (isWithholdingSelected) {
      return (
        <div>
          {witholdingMessage}
          <div>{`${withHoldingState.stateName} state income tax withholding not available.`}</div>
        </div>
      );
    } else {
      return (
        <div>
          {declinedWithHoldingMessage}
          <div>{`${withHoldingState.stateName} state income tax withholding not available.`}</div>
        </div>
      );
    }
  }
};

export default ReviewTaxwithholdingMessage;
